// extracted by mini-css-extract-plugin
export default {"container":"RecommendedFlag_container__YLE8R","recommendedFlag":"RecommendedFlag_recommendedFlag__19bfo"};